import React, { useState, useEffect } from "react";
import { Button, Modal, Layout, Table, Icon, Row, Col } from "antd";
import _ from "i18n";
import { connect } from "react-redux";
import { getInvoiceByEventDetails, displayCsvFile, displayPdfPaidInvoicesFile } from "../../../actions/thunks.js";
import { setFilteredItems } from "../../../actions/actions.js";
import { formatAmount } from "utils";
import moment from "moment";
import { Input } from 'antd';

const { Search } = Input;

const InvoiceDetail = ({
  statisticsFilter,
  paidInvoicesDetails,
  recapByDay,
  auth,
  getInvoiceByEventDetails,
  setFilteredItems,
  displayCsvFile,
  displayPdfPaidInvoicesFile,
  operationType
}) => {
  const [search, setSearch] = useState('');
  const [showSpinner, setShowSpinner] = useState(false);


  const columns = [
    {
      title: _("credit-note-number"),
      dataIndex: "officialNumber",
      align: "left",
      width: 97,
      whiteSpace: "normal"
    },
    {
      title: _("Date"),
      dataIndex: "documentDate",
      align: "left",
      width: 80,
      render: date => moment(date).format("DD/MM/YYYY")
    },

    {
      title: _("vcs"),
      dataIndex: "vcs",
      align: "left",
      width: 107,

    },


    {
      title: _("user-email"),
      align: "left",
      dataIndex: "user.mainEmail",
      width: 240,

    },

    {
      title: _("organization"),
      dataIndex: "clientOrganization",
      align: "left",
      width: 206,

    },


    {
      title: _("To"),
      align: "center",
      dataIndex: "issuer.abbreviation",
      width: 72,
      whiteSpace: "normal"

    },


    {
      title: _("amount"),
      dataIndex: "includingVatAmount",
      align: "center",
      width: 62,

      render: amount => formatAmount(amount)
    },

    {
      title: _("manual-amount"),
      align: "center",
      dataIndex: "manual.amount",
      width: 99,

      render: amount => amount ? formatAmount(amount) : formatAmount(0)

    },

    {
      title: _("manual-comment"),
      align: "left",
      dataIndex: "manual.comment",
      width: 109,

    },


    {
      title: _("Status"),
      align: "center",
      dataIndex: "status",
      width: 51,
      render: (text, record) => _(record.status)

    },

  ];



  const contains = (name, text) => {
    if (name === null) return;
    return (name.trim()).search(new RegExp(text, 'gi')) !== -1 || (name.trim()).search(new RegExp(text, 'gi')) === 0;
  };

  const handleSearch = (value) => {
    setSearch(value);

    let results = paidInvoicesDetails.items.filter((elem) => {

      return (contains(elem.user.mainEmail, value.trim()) || contains(elem.vcs, value.trim()) || contains(elem.clientOrganization, value.trim()) || contains(elem.manual && elem.manual.comment, value.trim()))
    });
    setFilteredItems(results);

  };

  const loadInvoices = (filterDay = null) => {
    getInvoiceByEventDetails(
      statisticsFilter.apps && statisticsFilter.apps.length > 0 ? statisticsFilter.apps : [],
      statisticsFilter.appRefs && statisticsFilter.appRefs.length > 0 ? statisticsFilter.appRefs : [],
      operationType ? operationType : null,
      filterDay,  // ← Utilise le paramètre
      auth.currentClient ? auth.currentClient.id : null,
      statisticsFilter.year && statisticsFilter.year.length > 0 ? statisticsFilter.year : [],
      statisticsFilter.appType && statisticsFilter.appType.length > 0 ? statisticsFilter.appType : []
    );
  };



  useEffect(() => {
    if (statisticsFilter.apps && statisticsFilter.apps.length > 0) {
      loadInvoices(null);  // ← Passe null au montage
    }
  }, []);

  useEffect(() => {
    loadInvoices(recapByDay.filterDay);  // ← Passe le filtre lors du changement
  }, [recapByDay.filterDay]);




  const calculSum = () => {
    return (paidInvoicesDetails.filteredItems).reduce((sum, { includingVatAmount, manual }) => {
      sum += parseInt(includingVatAmount);
      if (manual && manual.amount) {
        sum -= parseInt(manual.amount);
      }
      return sum
    }, 0
    );
  };


  const getCsvFile = () => {
    setShowSpinner(true);
    displayCsvFile(statisticsFilter.apps && statisticsFilter.apps.length > 0 ? statisticsFilter.apps : [], statisticsFilter.appRefs && statisticsFilter.appRefs.length > 0 ? statisticsFilter.appRefs : [], operationType ? operationType : null, recapByDay.filterDay, search.trim() !== '' ? search.trim() : null, auth.currentClient ? auth.currentClient.id : null, statisticsFilter.year && statisticsFilter.year.length > 0 ? statisticsFilter.year : [], statisticsFilter.appType && statisticsFilter.appType.length > 0 ? statisticsFilter.appType : []).then((res) => {
      setShowSpinner(false);
    });
  }

  const getPdfFile = () => {
    setShowSpinner(true);

    displayPdfPaidInvoicesFile(statisticsFilter.apps && statisticsFilter.apps.length > 0 ? statisticsFilter.apps : [], statisticsFilter.appRefs && statisticsFilter.appRefs.length > 0 ? statisticsFilter.appRefs : [], operationType ? operationType : null, recapByDay.filterDay, search.trim() !== '' ? search.trim() : null, auth.currentClient ? auth.currentClient.id : null, statisticsFilter.year && statisticsFilter.year.length > 0 ? statisticsFilter.year : [], statisticsFilter.appType && statisticsFilter.appType.length > 0 ? statisticsFilter.appType : []).then((res) => {
      setShowSpinner(false);
    });
  };

  return (
    <div className="stats-invoice-detail ">
      <div className="flex flex-row justify-between" >

        <div className="flex items-center justify-start">
          <div className="recap-day-title">
            {_('Invoices')}

          </div>

          <div className="ml-2" style={{ cursor: 'pointer' }} onClick={getCsvFile}>
            <Icon type="file-excel" style={{ fontSize: '20px', color: '#2495e1' }} />
          </div>

          <div className="ml-2" style={{ cursor: 'pointer' }} onClick={getPdfFile}>
            <Icon type="file-pdf" style={{ fontSize: '20px', color: '#2495e1' }} />
          </div>

        </div>
        <div className="w-1/3">
          <Search
            placeholder="input search text"
            onChange={({ target: { value } }) => handleSearch(value)}
            size={"small"}
            allowClear={true}
            value={search.trim()}
          />

        </div>
      </div>

      <div className="pb-4 relative">

        <Table
          rowKey="id"
          columns={columns}
          dataSource={paidInvoicesDetails.filteredItems.length > 0 ? paidInvoicesDetails.filteredItems : null}
          loading={paidInvoicesDetails.fetching}
          pagination={false}
          size="middle"
          className="ttp-invoice-detail-tab"
          scroll={{ x: false, y: 450 }}
        />

        {showSpinner ? <div className="div-fetching-file flex items-center justify-center ">

          <Icon type="sync" spin style={{ fontSize: '50px' }} />

        </div> : null
        }

      </div>

      <div className="flex flex-row justify-between  self-end mt-2">
        <div className="pr-4 border-right-line"> TOTAL</div>
        <div className="div-recap-amount-total"> {formatAmount(calculSum())} </div>
      </div>
    </div>
  );
}

const mapStateToProps = state => ({
  statisticsFilter: state.filters.statisticsFilter,
  paidInvoicesDetails: state.paidInvoicesDetails,
  recapByDay: state.recapByDay,
  auth: state.auth,
});

const mapDispatchToProps = {
  getInvoiceByEventDetails,
  setFilteredItems,
  displayCsvFile,
  displayPdfPaidInvoicesFile
};

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceDetail);




// WEBPACK FOOTER //
// ./app/components/Admin/statisctics/InvoiceDetail.js